import { Helmet } from "react-helmet";

const CookiePolicy = () => {
  return (
    <>
      <Helmet>
        <title>Cookie Policy - SageLabs | Conversational AI Solutions</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <main aria-labelledby="cookie-policy-title">
        <article className="text-sm pb-8">
          <h1 className="text-4xl mb-5">Cookie Policy</h1>
          <p className="font-semibold my-4">Last updated: April 14th, 2025</p>

          <section aria-labelledby="introduction">
            <p className="my-4">
              We, SageLabs Ltd, a company registered in England and Wales
              (Company Number: 12006438) with its registered office at C/O
              Clearstone Accountants Ltd, The Dock Hub, Wilbury Villas, Hove,
              West Sussex, United Kingdom, BN3 6AH ("SageLabs Ltd", "SageLabs",
              "we", "our", or "us") respect your privacy and are committed to
              protecting your personal data. This Cookie Policy aims to give you
              information on the cookies we use on sagelabs.tech and
              www.sagelabs.tech, including any associated subdomains ("website"
              or "SageLabs website"). In this policy, the Privacy Policy will
              apply to our processing of the data that we may collect via
              cookies.
            </p>
          </section>

          <section aria-labelledby="what-are-cookies">
            <h2 className="text-xl mt-8">
              What are cookies and what does this policy cover?
            </h2>
            <p className="my-4">
              Cookies are small pieces of text used to store information in web
              browsers. Cookies are used to store and receive identifiers and
              other information on computers, phones and other devices. Other
              technologies, including data that we may store on your web browser
              or device, identifiers associated with your device and other
              software, may be used for similar purposes. In this policy, we
              refer to all of these technologies as "cookies".
            </p>
            <p className="my-4">
              This policy explains how we use cookies and the choices you have.
              Except as otherwise stated in this policy, the Privacy Policy will
              apply to our processing of the data that we may collect via
              cookies.
            </p>
          </section>

          <section aria-labelledby="types-of-cookies">
            <h2 className="text-xl mt-8">Types of Cookies We Use</h2>
            <ul className="list-disc list-inside my-4">
              <li>
                Essential cookies: Required for the website to function properly
              </li>
              <li>Functional cookies: Remember your preferences and choices</li>
              <li>
                Analytics cookies (Google Analytics): We use Google Analytics to
                collect information about how visitors use our website. These
                cookies collect information in an anonymous form, including the
                number of visitors to the site, where visitors have come from,
                and the pages they visited. We use this information to improve
                our website and understand how people use it. Google Analytics
                cookies include:
                <ul className="ml-8 list-disc list-inside my-2">
                  <li>
                    _ga: Used to distinguish users (expires after 2 years)
                  </li>
                  <li>
                    \_ga_[site-specific]: Used to maintain session status
                    (expires after 2 years)
                  </li>
                  <li>
                    \_gid: Used to distinguish users (expires after 24 hours)
                  </li>
                </ul>
              </li>
              <li>Performance cookies: Help us improve website performance</li>
            </ul>
          </section>

          <section aria-labelledby="google-analytics">
            <h2 className="text-xl mt-8">Google Analytics</h2>
            <p className="my-4">
              This website uses Google Analytics, a web analytics service
              provided by Google, Inc. ("Google"). Google Analytics uses cookies
              to help us analyse how users use our site. The information
              generated by the cookie about your use of our website (including
              your IP address) will be transmitted to and stored by Google on
              servers in the United States. Google will use this information for
              the purpose of evaluating your use of our website, compiling
              reports on website activity for us and providing other services
              relating to website activity and internet usage. Google may also
              transfer this information to third parties where required to do so
              by law, or where such third parties process the information on
              Google's behalf. Google will not associate your IP address with
              any other data held by Google.
            </p>
            <p className="my-4">
              You can prevent Google Analytics from recognizing you on return
              visits to this website by disabling cookies on your browser or by
              using the{" "}
              <a
                href="https://tools.google.com/dlpage/gaoptout"
                className="text-blue-600 hover:underline"
              >
                Google Analytics Opt-out Browser Add-on
              </a>
              .
            </p>
          </section>

          <section aria-labelledby="how-we-use-cookies">
            <h2 className="text-xl mt-8">How We Use Cookies</h2>
            <p className="my-4">We use cookies to:</p>
            <ul className="list-disc list-inside my-4">
              <li>Remember your preferences and settings</li>
              <li>Understand how you interact with our website</li>
              <li>Improve our service based on analytics data</li>
              <li>Ensure our website functions correctly</li>
              <li>Provide a better user experience</li>
            </ul>
          </section>

          <section aria-labelledby="managing-cookies">
            <h2 className="text-xl mt-8">Managing Cookies</h2>
            <p className="my-4">
              You can manage your cookie preferences by clicking the "Manage
              preferences" button in the cookie consent banner.
            </p>
            <p className="my-4">
              Your browser or device may offer settings that allow you to choose
              whether browser cookies are set and to delete them. These controls
              vary by browser, and manufacturers may change both the settings
              that they make available and how they work at any time. Please be
              aware that these controls are distinct from the controls that we
              may offer you.
            </p>
            <p className="my-4">
              It is recommended that you ensure that your internet browser is
              up-to-date and that you consult the help and guidance provided by
              the developer of your internet browser regarding cookies.
            </p>
            <p className="my-4">
              For more information generally on cookies, including on how to
              disable or delete them, please refer to{" "}
              <a
                href="https://aboutcookies.org"
                className="text-blue-600 hover:underline"
              >
                aboutcookies.org
              </a>
              .
            </p>
          </section>

          <section aria-labelledby="third-party-cookies">
            <h2 className="text-xl mt-8">Third-Party Cookies</h2>
            <p className="my-4">
              Some third-party services we use may place cookies on your device.
              These help us analyse site usage and improve our services.
            </p>
          </section>

          <section aria-labelledby="contact-us">
            <h2 className="text-xl mt-8">Contact Us</h2>
            <p className="my-4">
              If you have any questions about our Cookie Policy, please contact
              us:
            </p>
            <ul className="list-disc list-inside my-4">
              <li>Email: hello@sagelabs.tech</li>
            </ul>
          </section>
        </article>
      </main>
    </>
  );
};

export default CookiePolicy;
